mutation SetLandingPageDomain($input: LandingPageDomainSetInput!) {
    landingPageDomainSet(input: $input) {
        domainId
    }
}
